import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { noselect } from "../../styles/common.css";
import Tabs from "@material-ui/core/Tabs";
import Button from "../Button";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  viewSelectorContainer: {
    "& .MuiTabs-flexContainer": {
      display: "flex",
      width: "100%",
      flexDirection: "flex-start",
      borderBottom: "1.5px solid #ccc",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
    "& .view": {
      cursor: "pointer",
      padding: "10px 20px",
      textAlign: "center",
      marginBottom: "-1.5px",
    },
    "& .activeView": {
      border: "1.5px solid #ccc",
      backgroundColor: "white",
      borderBottomColor: "transparent",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
    },
  },
});

export default function ViewSelector(props) {
  const classes = useStyles();
  const { activeView, setActiveView, callback, setOpenPopup } = props;

  return (
    <div className={classes.root}>
      <Tabs
        className={`${classes.viewSelectorContainer} ${noselect}`}
        value={activeView}
        onChange={(_, newValue) => {
          if (callback) {
            callback()
              .then(() => {
                setActiveView(newValue);
              })
              .catch((err) => {});
          } else {
            setActiveView(newValue);
          }
        }}
      >
        {props.children}
      </Tabs>
      <Button
        color="primary"
        varian="raised"
        onClick={() => {
          setOpenPopup(true);
        }}
      >
        Approve
      </Button>
    </div>
  );
}
